import useSWR from 'swr';

import { MODELS_PATH } from '@api/paths';
import { IDeviceModel } from '@models/IDeviceModel';
import { IIdentity } from '@models/IIdentity';
import { fetcher } from '@utils/swr-utils';

export default function useDeviceModel(identity: IIdentity) {
  const { data, error, isLoading } = useSWR<IDeviceModel>(
    `${MODELS_PATH}/${identity.type}/${identity.module}/${identity.key}/${identity.version}`,
    fetcher
  );

  return { deviceModel: data, isLoading, isError: Boolean(error) };
}
